var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.7537 0.664466V16.9364C27.7537 21.4022 26.5311 24.8619 24.0852 27.3173C23.1042 28.3029 21.9686 29.0896 20.6802 29.6773C18.7577 30.5594 16.4901 31 13.8773 31C9.44385 31 6.02306 29.7674 3.61401 27.3031C1.20496 24.8369 0 21.3835 0 16.9364H7.55736C7.55736 19.1689 8.11945 20.9045 9.24624 22.1407C10.1096 23.0897 11.2451 23.6748 12.6547 23.8942H12.6565C13.0842 23.962 13.5374 23.995 14.0134 23.995C16.0834 23.995 17.6819 23.3813 18.8078 22.155C19.9346 20.9259 20.4984 19.1867 20.4984 16.9355V7.44475H0V0.663574H27.7537V0.664466Z",
    fill: "#D0A95C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.684e5fe2d7a6b3831304a2a1ca7bff5e.svg";
export { ForwardRef as ReactComponent };